import { defineStore } from 'pinia'

import { SoftwareOut, SoftwareTypes } from '@/client'

export enum AuthType {
  AUTHENTICATE = 'authenticate',
  REAUTHENTICATE = 'reauthenticate',
}

export type ApplicationReauthenticateInfo = {
  application: SoftwareOut
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: () => any
}

export type Application2FaInfo = {
  applicationName: string
  applicationId: string
  applicationType: SoftwareTypes
  authType: AuthType
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: () => any
}

export const useApplicationReauthStore = defineStore('applicationStore', () => {
  const twoFactorAuthToHandle = ref<Application2FaInfo>()
  const reauthApplicationToHandle = ref<ApplicationReauthenticateInfo>()

  function setReauthApplicationToHandle(
    information: ApplicationReauthenticateInfo
  ) {
    reauthApplicationToHandle.value = information
  }

  function clearReauthApplicationToHandle() {
    if (reauthApplicationToHandle.value) {
      reauthApplicationToHandle.value.callback()
      delete reauthApplicationToHandle.value
    }
  }

  function set2FaApplicationToHandle(information: Application2FaInfo) {
    twoFactorAuthToHandle.value = information
  }

  function clear2FaApplicationToHandle() {
    if (twoFactorAuthToHandle.value) twoFactorAuthToHandle.value.callback()
    delete twoFactorAuthToHandle.value
  }

  return {
    twoFactorAuthToHandle,
    reauthApplicationToHandle: reauthApplicationToHandle,
    setReauthApplicationToHandle,
    clearReauthApplicationToHandle,
    set2FaApplicationToHandle,
    clear2FaApplicationToHandle: clear2FaApplicationToHandle,
  }
})
